<template>
  <ViewWrapper footer-orientation="vertical" class="location">
    <template #header>
      <AnimatedText el="h2" class="location__headline">
        {{ $t('view.selectLocation.whereLeaveImpact') }}
      </AnimatedText>
    </template>

    <template #footer>
      <InteractionHint
        class="location__interaction-hint"
        :label="$t('ui.interactionHint.rotate')"
        icon="rotate"
        animation-class="moveLeftRight"
      />

      <ButtonPill
        class="location__select-location"
        :disabled="!isOverValidLocation"
        @click="$router.replace({ name: 'globalShock' })"
      >
        {{ $t('view.selectLocation.proceedWithLocation') }}
      </ButtonPill>
    </template>
  </ViewWrapper>
</template>

<script>
import store from '../store';
import AnimatedText from '../components/AnimatedText';
import ButtonPill from '../components/ButtonPill';
import InteractionHint from '../components/InteractionHint';
import ViewWrapper from '../components/ViewWrapper';

export default {
  name: 'Home',

  components: {
    AnimatedText,
    ButtonPill,
    InteractionHint,
    ViewWrapper,
  },

  computed: {
    isOverValidLocation: () => store.isOverValidLocation,
  },
};
</script>

<style lang="scss" scoped>
.location {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
}

.location__headline {
  @include font-headline;
  max-width: 320px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.location__interaction-hint {
  margin-bottom: 20px;
}

.location__select-location {
  margin-bottom: calc(30px + env(safe-area-inset-bottom));
}
</style>
